import React from "react";

import nary from "@/modules/nary";

import { assetImg } from "@/modules/moduleImporter";

import StandardBetV4 from "../../StandardBetV4";

import "./index.scss";

import { IGameTableType } from "@/types/GlobalTypes";

export default class M27 extends React.PureComponent<IGameTableType> {
	render() {
		// const gwcn = getWinClassName,
		// win = this.props.win;
		const { langdata } = this.props;

		const singleGameAnimals = [
			{ "button": "rat",	   "group": "s12", "betType": "5:1" },
			{ "button": "ox",	   "group": "s11", "betType": "5:1" },
			{ "button": "tiger",   "group": "s10", "betType": "5.5:1" },
			{ "button": "rabbit",  "group": "s9",  "betType": "6.5:1" },
			{ "button": "dragon",  "group": "s8",  "betType": "7.5:1" },
			{ "button": "snake",   "group": "s7",  "betType": "9:1" },
			{ "button": "horse",   "group": "s6",  "betType": "11:1" },
			{ "button": "goat",	   "group": "s5",  "betType": "14:1" },
			{ "button": "monkey",  "group": "s4",  "betType": "19:1" },
			{ "button": "rooster", "group": "s3",  "betType": "29:1" },
			{ "button": "dog",	   "group": "s2",  "betType": "54:1" },
			{ "button": "pig",	   "group": "s1",  "betType": "54:1" }
		];



		const topRowComponent = (
		<div className="top">
			<StandardBetV4
					classes="sl-baccarat-bet-blue di"

					betType="1:1"
					betLabel={<div>Dì<br />地</div>}
					betNum="di"
					betGroup="di"

					commonProps={this.props}
				
			/>

			<StandardBetV4
					classes="sl-baccarat-bet-blue tie"

					betType= "9.5:1"
					betLabel= "Tie"
					betNum= "tie"
					betGroup= "tie"

					commonProps={this.props}
			/>


			<StandardBetV4
					classes= "sl-baccarat-bet-blue tian"

					betType= "1:1"
					betLabel={<div>Tiān<br />天</div>}
					betNum= "tian"
					betGroup= "tian"

					commonProps={this.props}
			/>
		</div>
		), bottomRowComponent = (
			<div className="bottom">
				{
					singleGameAnimals.map((animal, idx) =>
						<StandardBetV4
							key={"m27_single_" + animal.button + "_" + idx}
							classes="sl-baccarat-bet-blue"

							betLabel={langdata["txt_" + animal.button]}
							betNum={animal.button}
							betGroup={animal.group}
							betType={animal.betType}

							betImage={assetImg("shio_fight_bottom", animal.button)}

							commonProps={this.props}
						/>
					)
				}
			</div>
		);


		// console.log("m27 props", this.props);

		const portraitBetTemplate = (animal, idx) => (
			<StandardBetV4
				key={"m27_portrait_" + animal.button + "_" + idx}
				classes="col-xs-3 sl-baccarat-bet-blue"

				betLabel={langdata["txt_" + animal.button]}
				betNum={animal.button}
				betGroup={animal.group}
				betType={animal.betType}

				betImage={assetImg("shio_fight_bottom", animal.button)}

				commonProps={this.props}
			/>
		);

		return this.props.portrait ? (
			<div className="sl-table m27 full_v3">
				<div className="row top">
						<StandardBetV4
							classes="col-xs-4 sl-baccarat-bet-blue di"

							betType="1:1"
							betLabel={<div>Dì<br />地</div>}
							betNum="di"
							betGroup="di"

							commonProps={this.props}
						/>

						<StandardBetV4
							classes="col-xs-4 sl-baccarat-bet-blue tie"

							betType="9.5:1"
							betLabel="Tie"
							betNum="tie"
							betGroup="tie"

							commonProps={this.props}
						/>

						<StandardBetV4
							classes="col-xs-4 sl-baccarat-bet-blue tian"

							betType="1:1"
							betLabel={<div>Tiān<br />天</div>}
							betNum="tian"
							betGroup="tian"

							commonProps={this.props}
						/>
				</div>

				{
					nary(3).map(item =>
						<div key={"m27_portrait_row_" + item} className="row">
							{
								singleGameAnimals.slice((item - 1) * 4, item * 4).map(
									portraitBetTemplate
								)
							}
						</div>
					)
				}
			</div>
		) : this.props.maximised ? (
			<div className="sl-table m27 complete">
				{topRowComponent}

				{bottomRowComponent}
			</div>
		) : // DESKTOP MULTI TABLE
		(
			<div className="sl-table m27 multi-table">
				{topRowComponent}

				{bottomRowComponent}
			</div>
		);
	}
}